import React from "react"
import Layout from "../components/layout"
import { Jumbotron } from "reactstrap"
import CoursesStyle from "../components/styles/coursesStyles.module.scss"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { graphql } from "gatsby"

export const query = graphql`
  query($slug: String!) {
    contentfulCourses(slug: { eq: $slug }) {
      slug
      title
      description{
        json
      }
      subQuartersDetail {
        subquarters {
          title
          subQuarter
          description
        }
      }
      quarterinfo {
        title
        quarters {
          heading
          description
        }
      }
      rgbaColor{
        rgba
      }
      eachQuarterImages{
        file{
          url
        }
      }
      title
    }
  }
`

class CoursesTemplate extends React.Component {
  state = {}

  render() {
    const paragraph = this.props.data.contentfulCourses.description.json;
    const quarters = this.props.data.contentfulCourses.quarterinfo.quarters;
    const images = this.props.data.contentfulCourses.eachQuarterImages;
    const subQuarterDetails = this.props.data.contentfulCourses.subQuartersDetail.subquarters;
    const colorOpacity = 1 / (quarters.length - 1)
    const colorOpacityArray = []
    const rgba = this.props.data.contentfulCourses.rgbaColor.rgba
    let number = 0
    for (let i = 0; i < quarters.length; i++) {
      colorOpacityArray.push(number)
      number = number + colorOpacity
    }
    return (
      <Layout>
        <Jumbotron
          style={{ backgroundColor: `rgb(${rgba[0]}, ${rgba[1]}, ${rgba[2]})` }}
          className={CoursesStyle.jumbotron}
        >
          <div className={CoursesStyle.courseDescription}>
            <h1 className={CoursesStyle.title}>
              {this.props.data.contentfulCourses.title}
            </h1>
            <p className={CoursesStyle.p}>
              {documentToReactComponents(paragraph)}
            </p>
          </div>
        </Jumbotron>
        <section className={CoursesStyle.section}>
          <div className={CoursesStyle.sectionMainDiv}>
            <h1>Program Structure</h1>
            <h4>
              A four-quarter AI program in Data Science, Machine Learning,
              <br /> and Deep Learning.
            </h4>
          </div>
          <div className={"container-fluid"}>
            <div className={`${CoursesStyle.quartersMain}`}>
              {quarters.map((quarter, index) => {
                return (
                  <div
                    style={{
                      backgroundColor: `rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${colorOpacityArray[index]})`,
                    }}
                    className={`${CoursesStyle.eachQuarter}`}
                  >
                    <h3>{quarter.heading}</h3>
                    <p>{quarter.description}</p>
                  </div>
                )
              })}
            </div>
          </div>
        </section>
        <section className={`row container-fluid ${CoursesStyle.courseDetail}`}>
          <div className="column col-12">
            <main style = {{backgroundColor: (`rgb(${rgba[0]}, ${rgba[1]}, ${rgba[2]})`)}} className={CoursesStyle.verticalLine}></main>
            <h1 className={CoursesStyle.h1}>Detailed Program Structure</h1>
            <main className={CoursesStyle.verticalLine}></main>
            {subQuarterDetails.map((data, index) => {
              console.log(index);
              if (index % 2 === 0) {
                return (
                  <div
                    className={`${CoursesStyle.left} ${CoursesStyle.quarterDetail}`}
                  >
                    <div className={CoursesStyle.each}>
                      <div style = {{border: `2px solid rgb(${rgba[0]}, ${rgba[1]}, ${rgba[2]})`}} className={CoursesStyle.A}>
                        <p>{data.subQuarter}</p>
                      </div>
                      <div className={CoursesStyle.quarterDetailColumn}>
                        <h3>{data.title}</h3>
                        <div className={CoursesStyle.main}>
                          {images[index] !== undefined ? 
                         <div className={CoursesStyle.imageDiv}>
                         <img
                           src={images[index].file.url}
                           alt={images[index].title}
                         />
                       </div>:
                        <></>  
                        }
                         
                          <div>
                            <p>{data.description}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              } else {
                return (
                  <div
                    className={`${CoursesStyle.right} ${CoursesStyle.quarterDetail}`}
                  >
                    <div className={CoursesStyle.each}>
                      <div style = {{border: `2px solid rgb(${rgba[0]}, ${rgba[1]}, ${rgba[2]})`}} className={CoursesStyle.A}>
                        <p>{data.subQuarter}</p>
                      </div>
                      <div className={CoursesStyle.quarterDetailColumn}>
                        <h3>{data.title}</h3>
                        <div className={CoursesStyle.main}>
                        {images[index] !== undefined ? 
                         <div className={CoursesStyle.imageDiv}>
                         <img
                           src={images[index].file.url}
                           alt={images[index].title}
                         />
                       </div>:
                        <></>  
                        }
                          <div>
                            <p>{data.description}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              }
            })}
          </div>
        </section>
      </Layout>
    )
  }
}

export default CoursesTemplate
